(function () {
	'use strict';

	angular.module('qbePortal').controller('SummarySection', SummarySection);

	SummarySection.$inject = ['$scope', '$state', 'dynamicRouter', '$window','$filter'
		, 'quoteModelFactory' // labelService is not directly referenced but is required before initialisation
		, 'userInputRepository'
		, 'serviceResponseRepository'
		, 'Util'
		, 'labelService'
	];

	function SummarySection($scope, $state, dynamicRouter, window,$filter, quoteModelFactory, userInputRepository, serviceResponseRepository, Util, labelService) {
		var vm = this;
		var children = {}, sectionData = {};

		//dispatch label event as this summary view is outside the form controller
		Util.dispatchCustomEvent('register-labels');
		vm.labelService = labelService;

		vm.quoteModel = quoteModelFactory.create();

		$scope.$root.$on('selected-quote-changed', function () {
			vm.quoteModel = quoteModelFactory.create();
		});

		$scope.HTML_ID = $scope.name;
		$scope.hierarchyList = [$scope.name];

		vm.sectionName = $scope.name;

		vm.summary = $scope.summaryModel
		console.log('summary');
		console.log(vm.summary);
		vm.getLabel = function (labelKey) {
			var excessLabel = vm.labelService.getLabelForRemoteOption('driverExcess', labelKey);
			return (excessLabel) ? excessLabel.label : '';
		};

		vm.getRiderExcessLabel = function (labelKey) {
			var excessLabel = vm.labelService.getLabelForRemoteOption('riderExcess', labelKey);
			return (excessLabel) ? excessLabel.label : '';
		};

		vm.getWallConstructionLabel = function (labelKey) {
			var wallConstruction = this.getGlobalOptionLabel('wallsMadeOf', labelKey);
			return (wallConstruction) ? wallConstruction : '';
		};

		vm.getLabelForRemoteOption = function (labelSet, labelKey) {
			var label = vm.labelService.getLabelForRemoteOption(labelSet, labelKey);
			return (label) ? label.label : '';
		};

		vm.getGlobalOptionsFor = function (optionType) {
			return labelService.getGlobalOptionsFor(optionType);
		};

		vm.getGlobalOptionLabel = function (optionType, optionValue) {
			var optionKeyValues = this.getGlobalOptionsFor(optionType);
			console.log(optionValue);
			var label = null;
			var values=$filter('filter')(optionKeyValues, {value:optionValue}); 
			console.log(values);
			if (values && values.length>0) {
				label=values[0].label;				
			}
			return label;
		};

		vm.getGlobalOption = function (key, option) {
			option = option.trim();
			return labelService.getGlobalOption(key, option);
		};

		vm.getLiability = function () {
			var liability = vm.getGlobalOption('content', 'legal_liability');
			return (liability) ? liability.content : '';
		};

		vm.moveToState = function (step) {
			console.log('go', step);
			$state.go(dynamicRouter.getState(step));
		};

		vm.moveToHomeState = function (step) {
			console.log('go', step);
			if(vm.summary.annualCoverType.coverType==='contents_only' && step>2)
				step--;
			vm.moveToState(step);
		};

		vm.getStateName = function(address){
			return address!=null && address.state && address.state!=null ?address.state.replace(/AU_/,''):'';
		}

		vm.generateAddressText = function(address){
			
			var addressText='';
			addressText = address.addressLine1 + " " +address.city+", "+ vm.getStateName(address)+", "
				+address.postalCode;
			return addressText;
		}

		vm.liability = vm.getLiability();

		vm.getYearHomeBuilt = function(yearValue){
			var yearHomeBuiltOptions = this.getOptionsForBuildingYearBuilt('yearHomeBuilt');
			if(yearHomeBuiltOptions!=null && vm.summary.homeForm && vm.summary.homeForm.tellUsAboutTheBuilding.yearHomeBuilt
				&& vm.summary.homeForm.tellUsAboutTheBuilding.yearHomeBuilt){
				var filteredResult = $filter('filter')(yearHomeBuiltOptions,{value:vm.summary.homeForm.tellUsAboutTheBuilding.yearHomeBuilt});
				if(filteredResult.length>0){
					return filteredResult[0].label;
				}
			}
			return null;
		}

		vm.getOptionsForBuildingYearBuilt = function (fieldName) {
			var options = vm.getGlobalOptionsFor(fieldName);
			for (var i = 2000; i <= (new Date()).getFullYear(); i++) {
				options.unshift({
					label: String(i),
					value: String(i)
				});
			}
			return options;		
		}

		vm.includeFloodCover = function(){			
			var quickQuoteResponse = serviceResponseRepository.getLastResponseFrom('quote');
			if(quickQuoteResponse && quickQuoteResponse!=null){

				return quickQuoteResponse.includeFloodCover!=undefined && quickQuoteResponse.includeFloodCover==true;

			}
			return false;
		}
	}

	angular.module('qbePortal').directive('qbSummarySection', [function () {
		return {
			restrict: 'EA',
			controller: SummarySection,
			controllerAs: 'vm',
			transclude: true,
			scope: {
				init: '&',
				summaryModel: '='
			},
			link: function (scope, element, attrs, ctrl, transclude) {
				if (scope.setHierarchy !== undefined)
					hierarchyDecorator.attach(scope, {element: element, name: scope.name});

				transclude(scope, function (clone) {
					element.append(clone);
				});
			}
		}
	}]);
})();
